"use client";

import { c as _c } from "react/compiler-runtime";
import type { FragmentOfShopifyStorefront } from "@repo/graphql-shopify-storefront";
import type { Usable } from "react";
import Form from "next/form";
import type { ResolvedIntlConfig } from "react-intl";
import { useProductVariantBySelectedOptionsQuery } from "#/hooks/shopify";
import { useGetIntl } from "@repo/i18n/intl/client";
import { useDebouncedEffect } from "@react-hookz/web";
import { readFragmentShopifyStorefront } from "@repo/graphql-shopify-storefront";
import { Button } from "@repo/components/atoms/shadcn/button";
import { type ProductOption_Fragment, ProductVariant_Fragment } from "#/graphql/shopify-storefront/fragments";
import { subscribeToBackInStockNotificationsAction } from "@repo/klaviyo/actions";
import { cn } from "@repo/lib";
import { getShopifyCookies } from "@shopify/hydrogen-react";
import { useFormStatus } from "react-dom";
import { SlEnvolope } from "react-icons/sl";
import { toast } from "sonner";
import { useActionState } from "react";
export function SignUpForBackInStockSubscriptionForm(t0) {
  const $ = _c(57);
  const {
    className,
    dictionaryPromise,
    handle,
    lang,
    optionsMasked
  } = t0;
  const {
    pending
  } = useFormStatus();
  let t1;
  if ($[0] !== dictionaryPromise || $[1] !== lang) {
    t1 = {
      dictionaryPromise,
      lang
    };
    $[0] = dictionaryPromise;
    $[1] = lang;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const intl = useGetIntl(t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const [formState, formAction, isPending] = useActionState(subscribeToBackInStockNotificationsAction, t2);
  let t3;
  if ($[4] !== formState.data?.success || $[5] !== formState.serverError || $[6] !== intl) {
    t3 = () => {
      if (formState.serverError) {
        toast.error(intl.formatMessage({
          defaultMessage: "Unable to sign up for back in stock subscription",
          id: "tO+5NA",
          description: "Text for an unsuccessful sign up for back in stock subscription status title in the SignUpForBackInStockSubscriptionForm component"
        }), {
          description: intl.formatMessage({
            defaultMessage: "The sign up for back in stock subscription action failed with the following error: {message}",
            id: "erq+oT",
            description: "Text for an unsuccessful sign up for back in stock subscription status message in the SignUpForBackInStockSubscriptionForm component"
          })
        });
      }
      if (formState.data?.success === true) {
        toast.success(intl.formatMessage({
          defaultMessage: "You have successfully subscribed to back in stock notifications",
          id: "iFqAkY",
          description: "Text for a successful sign up for back in stock subscription status title in the cartLinesAdd component"
        }), {
          description: intl.formatMessage({
            defaultMessage: "You have successfully subscribed to back in stock notifications",
            id: "fB4MyD",
            description: "Text for a successful sign up for back in stock subscription status message in the cartLinesAdd component"
          })
        });
      }
    };
    $[4] = formState.data?.success;
    $[5] = formState.serverError;
    $[6] = intl;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== formState.serverError || $[9] !== isPending) {
    t4 = [isPending, formState.serverError];
    $[8] = formState.serverError;
    $[9] = isPending;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  useDebouncedEffect(t3, t4, 200, 500);
  let t5;
  if ($[11] !== handle || $[12] !== lang || $[13] !== optionsMasked) {
    t5 = {
      handle,
      lang,
      optionsMasked
    };
    $[11] = handle;
    $[12] = lang;
    $[13] = optionsMasked;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const data = useProductVariantBySelectedOptionsQuery(t5);
  if (!data) {
    return null;
  }
  const t6 = data.product?.variantBySelectedOptionsMasked;
  let t7;
  if ($[15] !== t6) {
    t7 = readFragmentShopifyStorefront(ProductVariant_Fragment, t6);
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const variantBySelectedOptions = t7;
  const variantId = variantBySelectedOptions?.id;
  let _shopify_y;
  if (typeof window !== "undefined") {
    let t8;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = getShopifyCookies(document.cookie);
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    const shopifyCookies = t8;
    _shopify_y = shopifyCookies._shopify_y;
  }
  let t8;
  if ($[18] !== className) {
    t8 = cn("grid gap-4", className);
    $[18] = className;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const t9 = Boolean(formState.serverError);
  let t10;
  if ($[20] !== formState.serverError) {
    t10 = cn({
      "border-destructive": formState.serverError
    });
    $[20] = formState.serverError;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== intl) {
    t11 = intl.formatMessage({
      defaultMessage: "Enter your email address",
      description: "Placeholder for email input in back in stock subscription form",
      id: "SoZOsk"
    });
    $[22] = intl;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t10 || $[25] !== t11 || $[26] !== t9) {
    t12 = <input aria-invalid={t9} autoComplete="email" className={t10} name="email" placeholder={t11} type="email" />;
    $[24] = t10;
    $[25] = t11;
    $[26] = t9;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== intl) {
    t13 = intl.formatMessage({
      defaultMessage: "Sign up for back in stock notification",
      description: "Button to sign up for back in stock notification",
      id: "puA1WR"
    });
    $[28] = intl;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <SlEnvolope />;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t13) {
    t15 = <Button aria-label={t13} className="btn absolute justify-self-end end-3" variant="ghost">{t14}</Button>;
    $[31] = t13;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t12 || $[34] !== t15) {
    t16 = <div className="relative">{t12}{t15}</div>;
    $[33] = t12;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== lang) {
    t17 = <input type="hidden" name="lang" value={lang} />;
    $[36] = lang;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== variantId) {
    t18 = <input type="hidden" name="variant_id" value={variantId} />;
    $[38] = variantId;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== _shopify_y) {
    t19 = <input type="hidden" name="_shopify_y" value={_shopify_y} />;
    $[40] = _shopify_y;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== intl) {
    t20 = intl.formatMessage({
      id: "E/La0O",
      defaultMessage: "Sign up for back in stock notification",
      description: "Text for back in stock subscription button"
    });
    $[42] = intl;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] !== intl) {
    t21 = intl.formatMessage({
      id: "E/La0O",
      defaultMessage: "Sign up for back in stock notification",
      description: "Text for back in stock subscription button"
    });
    $[44] = intl;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] !== pending || $[47] !== t20 || $[48] !== t21) {
    t22 = <Button aria-label={t20} className="btn btn-primary btn-solid btn-sm justify-self-end no-underline!" disabled={pending} variant="ghost">{t21}</Button>;
    $[46] = pending;
    $[47] = t20;
    $[48] = t21;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  let t23;
  if ($[50] !== t16 || $[51] !== t17 || $[52] !== t18 || $[53] !== t19 || $[54] !== t22 || $[55] !== t8) {
    t23 = <Form action={formAction} className={t8}>{t16}{t17}{t18}{t19}{t22}</Form>;
    $[50] = t16;
    $[51] = t17;
    $[52] = t18;
    $[53] = t19;
    $[54] = t22;
    $[55] = t8;
    $[56] = t23;
  } else {
    t23 = $[56];
  }
  return t23;
}